// extracted by mini-css-extract-plugin
export default {"svg-container":"styles_svg-container__sGNsK","category-svg-container":"styles_category-svg-container__gCxaE"};